<template>
    <div>
        <div class="actFormWrap">
            <div class="w30 dib">
                <a-form-item label="活动类型" class="requiredForm">
                    <a-input v-model="thisActTypeName" placeholder="活动类型" />
                </a-form-item>
            </div>
            <div class="w60 dib">
                <a-form-item label="活动名称" class="requiredForm">
                    <a-input v-model="thisActName" placeholder="活动名称" />
                </a-form-item>
            </div>
        </div>
        <div>
            <a-form-item label="活动说明">
                <a-textarea
                    v-model="thisActDesc"
                    placeholder="请填写活动说明"
                    :autoSize="{ minRows: 3, maxRows: 5 }"
                />
            </a-form-item>
        </div>
        <div>
            <a-form-item label="专家名称">
                <a-input
                    v-model="thisExpertName"
                />
                <p>该名称将作为片头字幕展示，若该视频的专家与课程专家一致则无需填写</p>
            </a-form-item>
        </div>
        <div>
            <a-form-item label="必修活动" class="requiredForm">
                <a-radio-group v-model="thisisRequired" name="thisisRequired" :default-value="'N'">
                    <a-radio value="Y">
                        是
                    </a-radio>
                    <a-radio value="N">
                        否
                    </a-radio>
                </a-radio-group>
                <span style="color: #999;">说明：勾选'“是 "代表学员除了完成指定数量的活动，还必须完成本活动，才能完成课程学习</span>
            </a-form-item>
        </div>
    </div>
</template>
<script>
export default {
    // actTypeId: '',    //环节id
    // actTypeName: '',    //环节标签
    // actDesc: '',    //环节描述
    // actName: '',    //环节标题
    // props:['actTypeId', 'actTypeName', 'actDesc', 'actName', 'type'],
    props:{
        actTypeId: {
            type:String,
            required: true
        },
        actTypeName: {
            type:String,
            required: true
        },
        actDesc: {
            type:String,
            required: true
        },
        expertName: {
            type:String,
            required: true
        },
        actName: {
            type:String,
            required: true
        },
        isRequired: {
            type:String,
            required: true
        },
        type:{
            type:String,
        }
    },
    data() {
        return {
            thisActName: '',
            thisActDesc: '',
            thisExpertName: '',
            thisActTypeName: '',
            thistype: '',
            thisisRequired: ''
        }
    },
    mounted (){
        this.initInfo();
    },
    methods: {
        initInfo(){
            this.thisActName = this.actName;
            this.thistype = this.type;
            this.thisisRequired = this.isRequired || 'N';
            let thisActDescText = '';
            if (this.thistype == 'popShowspxx'){
                thisActDescText = this.actDesc || '请按要求完成视频的观看';
            } else if (this.thistype == 'popShowtzyd'){
                thisActDescText = this.actDesc || '请完成本内容的阅读学习';
            } else if (this.thistype == 'popShowwlxx'){
                thisActDescText = this.actDesc || '请完成本内容的外链学习';
            }
            this.thisActDesc = this.actDesc || thisActDescText;
            this.thisActTypeName = this.actTypeName;
            this.thisExpertName = this.expertName;
            
        }
    },
};
</script>
<style lang="less">

</style>